import MemberPoints from './member_points.vue'

export default {
    path: 'memberPoints',
    component: MemberPoints
}